<template>
  <div>
    <component-header
      title="View Advertisement"
      :hasSearch="false"
      :hasReload="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push('/advertisement')"
    />
    <b-card>
      <div class="my-2 mb-4 ml-4 mr-4">
        <h2 style="color: #2c8ef8">Basic Details</h2>
        <b-row>
          <b-col md="4">
            <h5 class="h5-text">
              Advertisement Type :
              <span class="span-text">{{ adDetails && adDetails.type }}</span>
            </h5>
            <h5 class="h5-text">
              Placement :
              <span class="span-text">{{
                adDetails && adDetails.placement
              }}</span>
            </h5>
            <!-- <div>
              <h5 class="h5-text">
                Tags :
                <span
                  class="span-text"
                  v-for="tag in adobject.tag"
                  :key="tag"
                  >{{ tag }}</span
                >
              </h5>
            </div> -->
          </b-col>
          <b-col md="4">
            <h5 class="h5-text">
              Start Date :
              <span class="span-text">{{
                formateDate(
                  adDetails &&
                    adDetails.duration &&
                    adDetails.duration.startDate
                )
              }}</span>
            </h5>
            <h5 class="h5-text">
              End Date :
              <span class="span-text">{{
                formateDate(
                  adDetails && adDetails.duration && adDetails.duration.endDate
                )
              }}</span>
            </h5>
            <div v-for="(dataObj, index) in adDetails.data" :key="index">
              <h5
                class="h5-text"
                v-if="adDetails.type === 'VIDEO' && dataObj.navigateTo"
              >
                Navigate To :
                <a :href="dataObj.navigateTo" class="span-text">
                  {{ dataObj.navigateTo }}</a
                >
              </h5>
              <h5
                class="h5-text"
                v-if="adDetails.type === 'SLIDER' && dataObj.navigateTo"
              >
                Navigate To :
                <a :href="dataObj.navigateTo" class="span-text">
                  {{ dataObj.navigateTo }}</a
                >
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <h5 class="h5-text icon">
              Icon :<img
                :src="adDetails && adDetails.icon && adDetails.icon.fileUrl"
                alt=""
                class="ml-3 w-50"
              />
            </h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <h5 class="h5-text" v-if="adDetails.type === 'SLIDER'">Media:</h5>
            <div class="image-slider">
              <div v-for="(dataObj, index) in adDetails.data" :key="index">
                <div
                  class="image-sliders"
                  v-if="adDetails.type === 'SLIDER' && dataObj.url"
                >
                  <img
                    v-if="
                      dataObj &&
                      dataObj.url &&
                      dataObj.url.fileUrl &&
                      dataObj.url.fileUrl.length > 1
                    "
                    :src="dataObj && dataObj.url && dataObj.url.fileUrl"
                    alt=""
                  />
                </div>
                <div
                  class="h5-text video-slider"
                  v-if="adDetails.type === 'SLIDER' && dataObj.video"
                >
                  <video
                    v-if="
                      dataObj &&
                      dataObj.video &&
                      dataObj.video.type == 'UPLOADED'
                    "
                    :src="dataObj.video.url"
                    alt=""
                    class="video"
                    controls
                  />
                  <span
                    v-if="
                      dataObj &&
                      dataObj.video &&
                      dataObj.video.type == 'YOUTUBE'
                    "
                  >
                    <a :href="dataObj.video.url">{{ dataObj.video.url }}</a>
                  </span>
                </div>
              </div>
            </div>

            <div
              class="image"
              v-for="(dataObj, index) in adDetails.data"
              :key="index"
            >
              <div class="mt-0" v-if="adDetails.type === 'BANNER'">
                <h5 class="h5-text">Image:</h5>

                <img
                  v-if="
                    dataObj.url &&
                    dataObj.url.fileUrl &&
                    dataObj.url.fileUrl.length > 1
                  "
                  :src="dataObj && dataObj.url && dataObj.url.fileUrl"
                  alt=""
                />
              </div>
              <div
                class="h5-text video"
                v-if="adDetails && adDetails.type === 'VIDEO'"
              >
                <h5>Video :</h5>
                <video
                  v-if="
                    dataObj && dataObj.video && dataObj.video.type == 'UPLOADED'
                  "
                  :src="dataObj.video.url"
                  alt=""
                  class="video"
                  controls
                />
                <span
                  v-if="
                    dataObj && dataObj.video && dataObj.video.type == 'YOUTUBE'
                  "
                >
                  <a :href="dataObj.video.url">{{
                    dataObj && dataObj.video && dataObj.video.url
                  }}</a>
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <hr style="border-top: 1px solid #727cf5" class="mt-4" />
        <div>
          <h2 style="color: #2c8ef8; margin-bottom: 20px" class="mt-3">
            Address And Target
          </h2>
          <b-row>
            <b-col md="4">
              <h5 class="h5-text">
                country :
                <span class="span-text">{{
                  adDetails &&
                  adDetails.target &&
                  adDetails.target.address &&
                  adDetails.target.address.country
                }}</span>
              </h5>
              <h5 class="h5-text">
                Visibility :
                <span>
                  {{
                    adDetails &&
                    adDetails.target &&
                    adDetails.target.visibility &&
                    adDetails.target.visibility.type
                  }}&nbsp;{{
                    adDetails &&
                    adDetails.target &&
                    adDetails.target.visibility &&
                    adDetails.target.visibility.name
                  }}
                </span>
              </h5>
            </b-col>
            <b-col md="4">
              <h5 class="h5-text">
                state :
                <span class="span-text">{{
                  adDetails &&
                  adDetails.target &&
                  adDetails.target.address &&
                  adDetails.target.address.state
                }}</span>
              </h5>
              <h5 class="h5-text">
                Mininum Age Group :
                <span class="span-text">{{
                  adDetails &&
                  adDetails.target &&
                  adDetails.target.ageGroup &&
                  adDetails.target.ageGroup.min
                }}</span>
              </h5>
            </b-col>
            <b-col md="4">
              <h5 class="h5-text">
                City :
                <span class="span-text">{{
                  adDetails &&
                  adDetails.target &&
                  adDetails.target.address &&
                  adDetails.target.address.city
                }}</span>
              </h5>
              <h5 class="h5-text">
                Maximum Age Group :
                <span class="span-text">{{
                  adDetails &&
                  adDetails.target &&
                  adDetails.target.ageGroup &&
                  adDetails.target.ageGroup.max
                }}</span>
              </h5>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import ComponentHeader from "@/components/componentNewHeader";

export default {
  name: "viewAdvertisement",
  data() {
    return {};
  },
  components: {
    ComponentHeader,
  },
  computed: {
    ...mapGetters({
      adDetails: "advertisement/GetAdDetails",
    }),
  },
  methods: {
    ...mapActions({
      AdDetails: "advertisement/fetchAdDetails",
    }),
    formateDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
  async mounted() {
    await this.AdDetails(this.$route.params.id);
  },
};
</script>
<style scoped>
.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}
[col-4="image"] {
  background-color: aliceblue !important;
}
[btn-back="primary"] {
  background-color: #727cf5 !important;
  margin: 0px;
  height: 41px;
  color: white;
}
.img-avatar {
  margin-top: 150px !important;
}
.video-alignment {
  display: flex;
  align-items: center;
}
.icon {
  display: flex;
  justify-content: center;
  height: 70px;
  width: fit-content;
}
.image-slider {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}
.image-sliders img {
  margin: auto;
  max-height: 300px;
  max-width: 300px;
}
.video-slider .video {
  margin: auto;
  max-height: 300px;
  max-width: 300px;
}
.image img {
  margin: auto;
  max-height: 300px;
  width: fit-content;
}
.video {
  max-height: 300px;
  margin-top: 0px;
}
</style>
<style>
.span-text {
  font-size: 15px;
  font-weight: normal;
  line-height: 24px;
}
.h5-text {
  font-size: 15px;
  line-height: 17px;
}
</style>
